<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section">
<h1></h1>
<p>The reason why I wanted to write this book was to help disabled people. I wanted to stop the stigma that they feel daily, to make them feel included in society. It also happens to be a hidden part of human history which isn’t talked about. In order to truly understand disability, I knew I had to start from the beginning through its history. There’s a quote from Rod Laver which still means a lot to me, <em>in order to find the true understanding of something, you’ve got to learn about its history and see how it has evolved over time.</em> Which exactly what this book sets out to do. This book is here to teach the world that disabled people are the same as able-bodied people. They have the same feelings, dreams and ambitions in life as we do but because they look different, they are misrepresented. When I can prove that our mind is what defines us not our bodies, I really hope you take this newfound information, help disabled people, don’t ignore them; it’s not their fault they have the bodies they have—it’s genetics. Thank you so much for reading it.</p><br/>
<p style="text-indent: 00em;"><em>Molly Seymour</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?53c1adf2